import { Injectable } from '@angular/core';

export type TestRouteOffset = [number, number];
export type TestRouteData = {
  [key: string]: Array<TestRouteOffset>;
}
export type Test = {
  name: string;
  data: TestRouteData;
}
export type Tests = {
  [key: string]: Test;
}
@Injectable({
  providedIn: 'root'
})
export class TestService {
  private scale = 75;
  private tests: Tests = {
    'config1': {
      name: 'Config 1',
      data: {
        A1: [
          [-2, .5],
          [-1, .5],
          [0, .5],
          [0, 1.5],
          [-1, 1.5],
          [-1, .5],
          [-1, -.5],
          [0, -.5],
          [-1, .5],
          [-2, 1.5]
        ],
        B1: [
          [0, -1.5],
          [0, -.5],
          [1, -.5],
          [2, -.5]
        ],
        'B1.C1': [
          [1, -1.5],
          [1, -.5],
          [1, .5]
        ]
      }
    },
    'config2': {
      name: 'Config 2',
      data: {
        A1: [
          [-1, -1],
          [0, -1],
          [1, -1]
        ],
        'A1.B2': [
          [0, -1],
          [0, 0],
          [0, 1]
        ],
        'A1.B2.C2': [
          [0, 0],
          [1, 0],
          [1, -1]
        ]
      }
    },
    'config3': {
      name: 'Config 3',
      data: {
        'A1': [
          [-2.5, -1.5],
          [-1.5, -1.5],
          [-.5, -1.5],
          [1.5, -1.5]
        ],
        'A1.B2': [
          [-1.5, -1.5],
          [-1.5, -.5],
          [-1.5, .5]
        ],
        'A1.B2.C2': [
          [-1.5, -.5],
          [-2.5, -.5],
          [-2.5, 1.5],
          [-1.5, 1.5],
          [-.5, 1.5]
        ],
        'A1.B2.C2.D1': [
          [-1.5, 1.5],
          [-1.5, 2.5],
          [1.5, 2.5],
          [1.5, .5],
          [1.5, -1.5]
        ],
        'A1.E1': [
          [-.5, -2.5],
          [-.5, -1.5],
          [-.5, 1.5]
        ],
        'A1.G1': [
          [2.5, .5],
          [1.5, .5],
          [.5, .5]
        ]
      }
    },
    'config4': {
      name: 'Config 4',
      data: {
        A1: [
          [-.5, -1.5],
          [.5, -1.5],
          [1.5, -1.5]
        ],
        'A1.B2': [
          [.5, -1.5],
          [.5, -.5],
          [.5, .5]
        ],
        'A1.B2.C2': [
          [.5, -.5],
          [-.5, -.5],
          [-.5, .5],
          [-.5, 1.5],
          [1.5, 1.5],
          [1.5, -1.5]
        ],
        'A1.B2.C2.D1':[
          [-1.5,.5],
          [-.5,.5],
          [.5,.5]
        ]
      }
    },

  }

  constructor() { }

  MakeTest(name: string, centerX: number, centerY: number): undefined | Test {
    const info = this.tests[name];
    if (!info) return undefined;

    const test: Test = JSON.parse(JSON.stringify(info));
    for (const route in test.data) {
      if (!test.data.hasOwnProperty(route)) continue;
      const datum = test.data[route];
      for (const entry of datum) {
        entry[0] = (entry[0] * this.scale) + centerX;
        entry[1] = (entry[1] * this.scale) + centerY;
      }
    }
    return test;
  }

}
